"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("app.scss"); // styles
require("vendor");
require("core");
require("templates-cache.generated"); // generated by grunt 'ngtemplates' task
require("apps");
var appConfig_1 = require("appConfig");
var body = angular.element('body');
body.ready(function () {
    // update config via config.js
    if (window.profumoConfig) {
        angular.merge(appConfig_1.appConfig, window.profumoConfig);
    }
    angular.module('profumo.config').constant('config', appConfig_1.appConfig);
    /**
     * @ngdoc module
     * @name profumo-client
     * @packageName profumo-client
     * @description The root profumo module.
     */
    angular.bootstrap(body, [
        'profumo.config',
        'profumo.core',
        'profumo.apps',
    ].concat(appConfig_1.appConfig.apps || []), { strictDi: true });
    window['profumoIsReady'] = true;
});



//////////////////
// WEBPACK FOOTER
// ./scripts/index.ts
// module id = 388
// module chunks = 0